/**
 * Created by mac on 8/26/20
 */

const TooltipManager = function () {
    this.active = undefined;

    cleverapps.inputDispatcher.on("pointerdown", () => {
        this.onClick();
    });
    cleverapps.inputDispatcher.on("keyreleased", (key) => {
        if (key === InputDispatcher.KEY.escape) {
            this.onClick();
        }
    });
    cleverapps.inputDispatcher.on("mousescroll", () => {
        this.onClick();
    });
};

TooltipManager.prototype.create = function (target, options) {
    if (target.tooltipHandler) {
        this.remove(target);
    }

    target.baseScaleX = target.scaleX;
    target.baseScaleY = target.scaleY;
    target.tooltipHandler = cleverapps.UI.onClick(target, (touch) => {
        if (cleverapps.forces.isRunningForce()) {
            cleverapps.forces.closeRunningForce();
        }

        if (options.clickableArea) {
            const clickPosition = options.clickableArea.convertTouchToNodeSpace(touch);
            if (cc.rectContainsPoint(cc.rect(0, 0, options.clickableArea.width, options.clickableArea.height), clickPosition)) {
                cleverapps.tooltipManager.onClick(target, options);
            }
        } else {
            cleverapps.tooltipManager.onClick(target, options);
        }
    }, {
        interactiveScale: options.interactiveScale !== false
    });
};

TooltipManager.prototype.remove = function (target) {
    if (target.tooltipHandler) {
        target.tooltipHandler.remove();
        target.tooltipHandler = undefined;
    }
};

TooltipManager.prototype.onClick = cleverapps.accumulate(0, function (target, options) {
    if (!target && !this.active) {
        return;
    }

    options = options || {};
    const oldTarget = this.active && this.active.target;
    const needShow = target && oldTarget !== target;

    this._hide();
    if (needShow || options.forceShow) {
        this._show(target, options);
    }
});

TooltipManager.prototype.hide = function (target) {
    if (this.active && this.active.target === target) {
        this._hide();
    }
};

TooltipManager.prototype.clear = function () {
    if (this.active) {
        this.active.removeFromParent();
    }
};

TooltipManager.prototype._show = function (target, options) {
    const tooltip = new cleverapps.UI.Tooltip(target, options);

    cleverapps.Scenes.GetRunningScene().movingNode.addChild(tooltip);
    addCleaner(tooltip, () => {
        if (this.active === tooltip) {
            delete this.active;
        }
    });

    this.active = tooltip;
};

TooltipManager.prototype._hide = function () {
    if (this.active) {
        this.active.hide();
    }
};